@let obj = data();
@let reversedLayout = reverse();
@let showIcon = !hideIcon();
@let format = dateFormat();
<ul class="tw-flex tw-flex-col tw-gap-2" [ngbTooltip]="!hideTooltip() ? creator: null">
  <li class="tw-flex tw-items-center tw-gap-2" [class.tw-flex-row-reverse]="reversedLayout">
    @if (showIcon) {
      <sb-icon icon="clock"></sb-icon>
    }
    <div>
      @if (obj?.modifiedAt) {
        {{ obj?.modifiedAt?.toString() | date: format }}
      } @else if (obj?.createdAt) {
        {{ obj?.createdAt?.toString() | date: format }}
      } @else {
        -
      }
    </div>
  </li>
  <li class="tw-flex tw-items-center tw-gap-2" [class.tw-flex-row-reverse]="reversedLayout">
    @if (showIcon) {
      <sb-icon icon="user"></sb-icon>
    }
    <div>
      {{ obj?.modifiedBy?.name ?? obj?.createdBy?.name ?? ('lang.globals.unknown'|translate) }}
    </div>
  </li>
</ul>

<ng-template #creator>
  <sb-comp-display-created [data]="obj" [dateFormat]="format" [showHeadline]="true"></sb-comp-display-created>
</ng-template>
